module.exports = __webpack_public_path__ + "img/globe.af0069a.webp";